var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "clientsData-wrap"
  }, [_vm.licenses && _vm.licenses.length > 0 ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.licenses, function (license, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px",
        "margin-right": "8px"
      },
      attrs: {
        "src": require("../../assets/images/quotes.svg")
      }
    }), _vm._v(" " + _vm._s(_vm.getFileName(license.license_doc)) + " ")])]), _c('td', [_vm._v(_vm._s(_vm.getStateName(license.license_state)))]), _c('td', [_c('ul', {
      staticClass: "p-0 license-list"
    }, [_c('li', [_vm._v("License No: " + _vm._s(license.license_number))]), _c('li', [_vm._v("License Valid Until: " + _vm._s(_vm.formatDate(license.license_exp_date)))])])]), _c('td', [_vm._v(_vm._s(license.license_resident === 1 ? 'Permanent' : 'Non-Permanent'))]), _c('td', [_c('div', {
      staticClass: "action-icons"
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "me-2",
      attrs: {
        "href": "#",
        "title": "Preview"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.previewFile(license);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "#",
        "title": "Delete"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.openDeleteModal(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })])])])]);
  }), 0)])]) : _c('div', {
    staticClass: "text-center py-4"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No licenses added yet.")])]), _c('b-modal', {
    staticClass: "delete-request-modal",
    attrs: {
      "id": "delete-license-modal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    model: {
      value: _vm.showDeleteModal,
      callback: function callback($$v) {
        _vm.showDeleteModal = $$v;
      },
      expression: "showDeleteModal"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/exclaim.svg")
    }
  })]), _c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Delete License")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Please note that once you delete this license, the action cannot be undone.")]), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("Do you want to proceed with this delete request?")]), _c('div', {
    staticClass: "d-flex justify-content-center gap-3"
  }, [_c('b-button', {
    staticClass: "px-4",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showDeleteModal = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "px-4",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Delete ")])], 1)])]), _c('b-modal', {
    staticClass: "file-preview-modal",
    attrs: {
      "id": "file-preview-modal",
      "size": "lg",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    model: {
      value: _vm.showPreviewModal,
      callback: function callback($$v) {
        _vm.showPreviewModal = $$v;
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "preview-header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.previewFileName))]), _c('button', {
    staticClass: "btn-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function click($event) {
        _vm.showPreviewModal = false;
      }
    }
  })]), _vm.previewUrl ? _c('div', {
    staticClass: "preview-body"
  }, [_vm.isImageFile ? _c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.previewUrl,
      "alt": _vm.previewFileName
    }
  })]) : _vm.isPdfFile ? _c('div', {
    staticClass: "pdf-preview"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.previewUrl,
      "width": "100%",
      "height": "500px",
      "frameborder": "0"
    }
  })]) : _c('div', {
    staticClass: "no-preview"
  }, [_c('p', [_vm._v("Preview not available for this file type.")]), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.previewUrl,
      "download": _vm.previewFileName
    }
  }, [_vm._v("Download File")])])]) : _vm._e()])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Image")]), _c('th', [_vm._v("State")]), _c('th', [_vm._v("License Details")]), _c('th', [_vm._v("Resident")]), _c('th', [_vm._v("Action")])])]);
}]

export { render, staticRenderFns }